import { render, staticRenderFns } from "./SearchStatsHeader.vue?vue&type=template&id=2ea35720&"
import script from "./SearchStatsHeader.vue?vue&type=script&lang=ts&"
export * from "./SearchStatsHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports